import { useState } from "react";
import { signInWithPopup, signOut } from "firebase/auth";
import { auth, Providers } from "../../firebase";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const AuthLogin = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const signInWithGoogle = () => {
    signInWithPopup(auth, Providers.google)
      .then((res) => {
        navigate("/goals");
        Cookies.set("user", JSON.stringify(res.user)); // Ensure you're saving only serializable data
      })
      .catch((error) => {
        setErrorMessage(error.code + ": " + error.message);
      });
  };

  const logout = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
        Cookies.remove("user"); // Remember to clear the cookie on logout
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      {auth.currentUser ? (
        <button
          onClick={logout}
          className="px-2 py-1 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm"
        >
          Logout ({auth.currentUser.displayName})
        </button>
      ) : (
        <button
          onClick={signInWithGoogle}
          className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          Log in
        </button>
      )}

      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default AuthLogin
